import { useCallback } from 'react';

import thematicMeetingService from '@/api/thematic-meetings/thematicMeetingService';
import {
    useAgendaGeneration,
    type AgendaGenerationRequest,
} from '@/components/MeetingAgendaBuilder/useAgendaGeneration';

/**
 * The thematic meeting's agenda generation: the same wait as the post-review meeting's, on this feature's
 * endpoint. The generated agenda is returned, never written, for the manager to add or replace, with the
 * summary and the alerts the AI wrote for them. It is written in the reader's language, which the server reads
 * from the Accept-Language header. Only the context is sent: the manager is asked for no objective here.
 */
export const useThematicMeetingAgendaGeneration = (meetingId: string) => {
    const request = useCallback<AgendaGenerationRequest>(
        ({ correlationId, context }) =>
            thematicMeetingService.generateAgenda(meetingId, { correlationId, context }),
        [meetingId],
    );

    return useAgendaGeneration(request);
};
